var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "message-details",
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: _vm.messageData.width,
            "before-close": _vm.beforeClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.messageData.data
            ? [
                _c(
                  "div",
                  {
                    staticClass: "details",
                    class: _vm.messageData.data.button_template ? "" : "mb14",
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { staticClass: "left" }, [
                          _vm.messageData.data.image
                            ? _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.messageData.data.image,
                                  alt: "",
                                },
                              })
                            : _c("div", { staticClass: "left-icon" }, [
                                _c("i", { staticClass: "iconfont iconxiaoxi" }),
                              ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticClass: "top" },
                            [
                              _c(
                                "el-tag",
                                { attrs: { size: "small", effect: "dark" } },
                                [_vm._v(_vm._s(_vm.messageData.data.cate_name))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.messageData.data.buttons.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleConfirm(
                                        _vm.messageData.data.buttons[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mt10 content over-text" },
                                    [_vm._v(_vm._s(_vm.messageData.data.title))]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt10 bottom" }, [
                                    _vm._v(
                                      _vm._s(_vm.messageData.data.message)
                                    ),
                                  ]),
                                ]
                              )
                            : _c("div", { staticClass: "pointer" }, [
                                _c(
                                  "div",
                                  { staticClass: "mt10 content over-text" },
                                  [_vm._v(_vm._s(_vm.messageData.data.title))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt10 bottom" }, [
                                  _vm._v(_vm._s(_vm.messageData.data.message)),
                                ]),
                              ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.messageData.data.buttons.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _vm.messageData.data.cate_name !== "考勤"
                          ? _vm._l(
                              _vm.messageData.data.buttons,
                              function (item, index) {
                                return _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "small",
                                      disabled: _vm.selectedType.includes(
                                        item.action
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleConfirm(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("message-handle-popup", {
        ref: "messageHandlePopup",
        attrs: { detail: _vm.messageData.data },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }